<template>
  <div class="config" v-loading="loading">
    <el-row class="mb10" v-if="list != null && list.length>0">
      <el-col :span="13">
        <el-alert
          v-show="weakCorrelation"
          :title="weakCorrelation"
          type="error"
          :closable="false"
          style="text-align:left;"
        />
      </el-col>
      <el-col :span="8" style="text-align: right; float: right;">
        <el-button @click="createProductGroupSubItem(0)" type="primary" :disabled="loading">{{ $t('addConfigModule.saveChanges') }}</el-button>
        <el-button @click="createProductGroupSubItem(1)" type="primary" :disabled="loading">{{ $t('addConfigModule.saveClose') }}</el-button>
        <el-button @click="closeHandler" type="primary">{{ $t('addConfigModule.close') }}</el-button>
      </el-col>
      <el-col :span="3" style="float: right;">
        <span>{{ $t('addConfigModule.numberOf') }}：
          <el-input-number
            v-model="tcount" controls-position="right"
            :precision="0" :min="0" size="mini" style="width: 100px;"
          />
        </span>
      </el-col>
    </el-row>

    <AddProductTable
      ref="addProductTable"
      :data="list"
      :configuration-group="configurationGroup"
      @load="load"
    />
    <el-dialog :title="$t('addConfigModule.productConfigRelationshipReminder')" :visible.sync="dialogProductRuleVisibleZero" :append-to-body="true" align="center" width="700px">
      <table>
        <tr v-for="(item,j) in productRuleList" :key="j">
          <td style="text-align: left">
            <span v-html="item" />
          </td>
        </tr>
      </table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogProductRuleVisibleZero = false;productRuleList=[]">{{ $t('addConfigModule.cancel') }}</el-button>
        <el-button type="primary" @click="continueCreateProductGroupSubItem(0)">{{ $t('addConfigModule.continueSavingChanges') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('addConfigModule.productConfigRelationshipReminder')" :visible.sync="dialogProductRuleVisibleOne" :append-to-body="true" align="center" width="700px">
      <table>
        <tr v-for="(item,j) in productRuleList" :key="j">
          <td style="text-align: left">
            <span v-html="item" />
          </td>
        </tr>
      </table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogProductRuleVisibleOne = false;productRuleList=[]">{{ $t('addConfigModule.cancel') }}</el-button>
        <el-button type="primary" @click="continueCreateProductGroupSubItem(1)">{{ $t('addConfigModule.continueSavingClose') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// xe-utils 函数库
import XEUtils from 'xe-utils';
import api from '../../api';
import AddProductTable from '../components/AddProductTable';
import { getProductListParam, getGroupType } from '@/utils/numberFormater';
import eventBus from '@/utils/eventBus';
export default {
  components: {
    AddProductTable
  },
  props: {
    currentRow: {
      type: Object,
      default: function () {
        return {};
      }
    },
    configurationGroup: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      productRuleList: [],
      dialogProductRuleVisibleZero: false,
      dialogProductRuleVisibleOne: false,
      list: [],
      basicData: [],
      loading: false,
      activeNames: null,
      weakCorrelation: '',
      height: 0,
      tcount: 1
    };
  },
  methods: {
    getGroupType,
    getData (row) {
      this.currentRow = row;
      this.getWeakCorrelation();
      this.list = [];
      this.loading = true;
      let productNameParam = '';
      if (row.productItems) {
        row.productItems.forEach(element => {
          if (element.productCode === row.subProductCode) {
            productNameParam = element.productName;
          }
        });
      }

      // 添加产品页面光模块需要懒加载,已添加产品页面,光模块不需要懒加载
      let param = {
        productCode: row.isAddition ? row.productCode : row.subProductCode,
        productName: row.isAddition ? row.productName : productNameParam,
        projectId: row.projectId,
        groupId: row.groupId,
        subId: row.subId,
        opticalModuleLazy: false
      };
      if (row.isAddition) {
        param.opticalModuleLazy = true;
        // 添加产品页面填好数量后点击展开配置,回显填好的数量
        let purchaseQuantity = row.purchaseQuantity;
        api.initAllRulePreciseCorrelationProductList(param)
          .then(res => {
            let json = res.data;
            this.loading = false;
            if (json.status === '200') {
              let result = json.data;
              if (result.length > 0) {
                result[0].productInitListVO.purchaseQuantity = purchaseQuantity || 0;
              }
              this.list = result;
            } else {
              this.$notify.error(json.data);
            }
          })
          .catch(() => {
            this.$notify.info(this.$t('addConfigModule.networkAnomaly'));
            this.loading = false;
          });
      } else {
        api
          .getAllRulePreciseCorrelationAddedProductList(param)
          .then(res => {
            let json = res.data;
            this.loading = false;
            if (json.status === '200') {
              this.list = json.data;
              // 获取套数
              api.selectTcountbySubId({ params: { subId: row.subId } }).then(res => {
                let tcountJson = res.data;
                if (tcountJson.status === '200') {
                  this.tcount = tcountJson.data;
                } else {
                  this.$notify.info(this.$t('addConfigModule.networkAnomaly'));
                }
              });
            } else {
              this.$notify.error(json.data);
            }
          })
          .catch(() => {
            this.$notify.info(this.$t('addConfigModule.networkAnomaly'));
            this.loading = false;
          });
      }
    },
    load (tree, treeNode, resolve) {
      let param = {
        productCode: this.currentRow.subProductCode,
        nodeId: tree.nodeId,
        nodeName: tree.nodeName,
        opticalModule: tree.opticalModule,
        nodeLevel: tree.nodeLevel,
        projectId: this.currentRow.projectId,
        groupId: this.currentRow.groupId,
        subId: this.currentRow.subId
      };
      if (this.currentRow.isAddition) {
        param.productCode = this.currentRow.productCode;
        api.initRulePreciseCorrelationProductList(param).then(res => {
          let json = res.data;
          treeNode.loaded = true;
          if (json.status === '200') {
            tree.children = json.data;
            XEUtils.eachTree(this.ProductInitListVO, item => {
              if (item.nodeId === tree.nodeId) {
                item.children = json.data;
                return false;
              }
            });
            resolve(json.data);
          } else {
            this.$notify.error(json.data);
          }
        })
          .catch(() => {
            this.$notify.info(this.$t('addConfigModule.networkAnomaly'));
          });
        treeNode.loading = false;
      } else {
        api
          .getRulePreciseCorrelationAddedProductList(param)
          .then(res => {
            let json = res.data;
            treeNode.loaded = true;
            treeNode.loading = false;
            if (json.status === '200') {
              tree.children = json.data;
              XEUtils.eachTree(this.list, item => {
                if (item.nodeId === tree.nodeId) {
                  item.children = json.data;
                  return false;
                }
              });
              resolve(json.data);
            } else {
              this.$notify.error(json.data);
            }
          })
          .catch(() => {
            this.$notify.info(this.$t('addConfigModule.networkAnomaly'));
          });
      }
    },
    // 添加至配置组
    createProductGroupSubItem (isClose) {
      let paramData = this.$refs.addProductTable.tableData;
      if (paramData == null) {
        return false;
      }
      let param = getProductListParam(paramData);
      // return
      if (param.productInitListVOS.length > 0) {
        let body = {
          groupId: this.configurationGroup.groupId,
          productInitListVOS: param.productInitListVOS,
          productInitVO: param.productInitVO,
          tcount: this.tcount
        };
        api.getConfigValidateInfo(body).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.productRuleList = json.data;
            if (this.productRuleList.length > 0) {
              if (isClose === 0) {
                this.dialogProductRuleVisibleZero = true;
              } else if (isClose === 1) {
                this.dialogProductRuleVisibleOne = true;
              }
            }
          }else if (json.status === '10001') {
            if (this.currentRow.isAddition) {
              let body = {
                groupId: this.configurationGroup.groupId,
                productInitListVOS: param.productInitListVOS,
                productInitVO: this.currentRow,
                tcount: this.tcount,
                typeOptions: 2
              };
              this.loading = true;
              api.createProductGroupSubItem(body).then(res => {
                  let json = res.data;
                  if (json.status === '200') {
                    this.tcount = 1;
                    // 跳转到已添加产品
                    this.$message({
                      showClose: true,
                      duration: 800,
                      message: this.$t('addConfigModule.addGroupNameSuccess'),
                      type: 'success'
                    });
                    // 关闭弹出框
                    if (isClose === 1) {
                      this.close();
                    }
                    // 直接改变变量,会报错的,所以不直接修改this.$refs.addProductTable.data而是修改this.list
                    // this.$refs.addProductTable.data = []
                    // this.$refs.addProductTable.data = this.list
                    // 由于vue对数组不进行深度监视,导致数组内部改变页面不会重新渲染,所以这里进行了浅拷贝后重新赋值
                    this.list = [...this.list];
                    // this.clearProductList();
                    // this.$refs.mychild.getProductQuantity();
                  } else {
                    this.$notify.error(json.err);
                  }
                  this.fullscreenLoading = false;
                  this.loading = false;
                }).catch(() => {
                  this.loading = false;
                  this.fullscreenLoading = false;
                  this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
                });
            } else {
              let body = {
                groupId: this.currentRow.groupId,
                projectId: this.currentRow.projectId,
                subId: this.currentRow.subId,
                groupType: this.getGroupType(this.configurationGroup.isService),
                productInitListVOS: param.productInitListVOS,
                tcount: this.tcount
              };
              this.loading = true;
              api.addProductGroupSubItem(body).then((res) => {
                let json = res.data;
                if (json.status === '200') {
                  this.tcount = 1;
                  // this.initGetProductList();
                  this.getData(this.currentRow);
                  eventBus.$emit('loadData');
                  // 关闭弹出框
                  if (isClose === 1) {
                    this.close();
                  }
                  this.$message({
                    showClose: true,
                    duration: 800,
                    message: this.$t('addConfigModule.addGroupNameSuccess'),
                    type: 'success'
                  });
                } else {
                  this.$notify.success(json.err);
                }
                this.loading = false;
              }).catch(() => {
                this.loading = false;
                this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
              });
            }
          }
        }).catch(() => {
          this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
        });
      } else {
        this.$message({
          showClose: true,
          duration: 800,
          message: this.$t('addConfigModule.changeNotProduct'),
          type: 'error'
        });
        // this.$notify.error("您没有选择任何产品！");
      }
      eventBus.$emit('resetSelectedHost');
    },
    // 添加至配置组
    continueCreateProductGroupSubItem (isClose) {
      this.dialogProductRuleVisibleOne = false;
      this.dialogProductRuleVisibleZero = false;
      let paramData = this.$refs.addProductTable.tableData;
      if (paramData == null) {
        return false;
      }
      let param = getProductListParam(paramData);
      // return
      if (param.productInitListVOS.length > 0) {
        if (this.currentRow.isAddition) {
          let body = {
            groupId: this.configurationGroup.groupId,
            productInitListVOS: param.productInitListVOS,
            productInitVO: this.currentRow,
            tcount: this.tcount,
            typeOptions: 2
          };
          this.loading = true;
          api.createProductGroupSubItem(body)
            .then(res => {
              let json = res.data;
              if (json.status === '200') {
                this.tcount = 1;
                // 跳转到已添加产品
                this.$message({
                  showClose: true,
                  duration: 800,
                  message: this.$t('addConfigModule.addGroupNameSuccess'),
                  type: 'success'
                });
                // 关闭弹出框
                if (isClose === 1) {
                  this.close();
                }
                // 直接改变变量,会报错的,所以不直接修改this.$refs.addProductTable.data而是修改this.list
                // this.$refs.addProductTable.data = []
                // this.$refs.addProductTable.data = this.list
                // 由于vue对数组不进行深度监视,导致数组内部改变页面不会重新渲染,所以这里进行了浅拷贝后重新赋值
                this.list = [...this.list];
                // this.clearProductList();
                // this.$refs.mychild.getProductQuantity();
              } else {
                this.$notify.error(json.err);
              }
              this.fullscreenLoading = false;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
              this.fullscreenLoading = false;
              this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
            });
        } else {
          let body = {
            groupId: this.currentRow.groupId,
            projectId: this.currentRow.projectId,
            subId: this.currentRow.subId,
            groupType: this.getGroupType(this.configurationGroup.isService),
            productInitListVOS: param.productInitListVOS,
            tcount: this.tcount
          };
          this.loading = true;
          api.addProductGroupSubItem(body).then((res) => {
            let json = res.data;
            if (json.status === '200') {
              this.tcount = 1;
              // this.initGetProductList();
              this.getData(this.currentRow);
              eventBus.$emit('loadData');
              // 关闭弹出框
              if (isClose === 1) {
                this.close();
              }
              this.$message({
                showClose: true,
                duration: 800,
                message: this.$t('addConfigModule.addGroupNameSuccess'),
                type: 'success'
              });
            } else {
              this.$notify.error(json.err);
            }
            this.loading = false;
          }).catch(() => {
            this.loading = false;
            this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
          });
        }
      } else {
        this.$message({
          showClose: true,
          duration: 800,
          message: this.$t('addConfigModule.changeNotProduct'),
          type: 'error'
        });
        // this.$notify.error("您没有选择任何产品！");
      }
    },
    closeHandler () {
      this.tcount = 1;
      eventBus.$emit('loadData');
      this.$refs.addProductTable.search = '';
      eventBus.$emit('resetSelectedHost');
      this.close();
    },
    getWeakCorrelation () {
      // 如果是添加产品页面根据产品行上的productCode查询弱关联,如果是已添加产品页面,根据subProductCode查询弱关联
      let productCode = this.currentRow.isAddition ? this.currentRow.productCode : this.currentRow.subProductCode;
      api.getWeakCorrelation({ params: { productCode } }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          if (json.data !== null) {
            this.weakCorrelation = json.data.configurationadvice;
          } else {
            this.weakCorrelation = '';
          }
        }
      }).catch((e) => {
        console.log(e);
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
      });
    },
    close () {
      this.$parent.$parent.drawer = false;
    }
  }
};
</script>

<style lang="scss">
.config {
  overflow-y: auto;
  margin: 10px;
  .el-table__expand-icon {
    .el-icon-arrow-right:before {
      content: "\e6d9"
    }
  }
  .el-table__expand-icon--expanded {
    transform: rotate(0deg);
    .el-icon-arrow-right:before {
      content: "\e6d8"
    }
  }
  .el-collapse {
    border: none !important;
  }
  .el-alert{
    padding: 3px 16px;
  }
  .el-collapse-item__header {
    height: 28px!important;
    line-height: 28px!important;
  }
  .title {
    width:100%;
    text-align: center;
    color: #fff !important;
    background-color: #36BADE !important;
  }
  .mb10 {
    margin-bottom: 10px;
  }
}
</style>
